// Contract 2: tokens exist only in memory and travel over the trusted WebView's CSRF-protected session.
const configuration = () => {
  const value = document.querySelector('meta[name="storefront-mobile"]')?.content
  if (!value || window.top !== window) return null
  try { return JSON.parse(value) } catch { return null }
}
const send = (message) => {
  if (!configuration()) return
  if (window.webkit?.messageHandlers?.storefront) window.webkit.messageHandlers.storefront.postMessage(message)
  else window.StorefrontBridge?.postMessage(JSON.stringify(message))
}
const status = (message) => document.querySelectorAll("[data-storefront-native-status]").forEach(node => { node.textContent = message })
const request = (path, method, body) => fetch(path, {
  method, credentials: "same-origin", redirect: "error",
  headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" },
  body: JSON.stringify(body)
})

window.StorefrontNative = {
  async register(device) {
    const config = configuration()
    if (!config?.signed_in) return
    try {
      const response = await request(`${config.base}/devices`, "POST", { device })
      if (response.ok) {
        send({ type: "registered", ...(await response.json()), identity: config.identity })
        status(device.permission === "granted" ? "Notifications are allowed on this device." : "Notifications are disabled on this device. You can continue shopping.")
      } else if (response.status === 401) send({ type: "session_expired" })
      else status("Notifications could not be updated. Try again later.")
    } catch { status("Reconnect to update notification settings.") }
  }
}

document.addEventListener("turbo:load", () => {
  const config = configuration()
  if (config) send({ type: "ready", signed_in: config.signed_in, identity: config.identity || "", push_enabled: config.push_enabled })
})
document.addEventListener("click", async (event) => {
  const link = event.target.closest("a[href]")
  const context = configuration()
  if (link && context) {
    const url = new URL(link.href, window.location.href)
    if (url.origin === window.location.origin && url.pathname.startsWith(`${context.root}/orders/`) && /\/invoices\/\d+$/.test(url.pathname)) {
      event.preventDefault()
      try {
        const response = await fetch(url.href, { credentials: "same-origin", redirect: "error" })
        if (!response.ok || !response.headers.get("Content-Type")?.startsWith("application/pdf")) throw new Error("Unavailable")
        const blob = await response.blob()
        if (blob.size > 10 * 1024 * 1024) throw new Error("Too large")
        const reader = new FileReader()
        reader.onload = () => send({ type: "document", data: reader.result.split(",")[1] })
        reader.readAsDataURL(blob)
      } catch { window.alert("The invoice could not be opened. Check your connection and account access, then try again.") }
      return
    }
  }
  const button = event.target.closest("[data-storefront-native-action]")
  const config = configuration()
  if (!button || !config) return
  event.preventDefault()
  const action = button.dataset.storefrontNativeAction
  if (action === "preference") {
    button.disabled = true
    try {
      const enabled = button.dataset.enabled === "true"
      const response = await request(`${config.base}/preferences`, "PATCH", { preference: { transactional: enabled } })
      if (response.ok && button.getAttribute("role") === "switch") {
        button.setAttribute("aria-checked", String(enabled))
        button.dataset.enabled = String(!enabled)
      }
      status(response.ok ? (enabled ? "Order updates are enabled." : "Order updates are paused.") : "Sign in again to update your preference.")
    } catch { status("Reconnect to update your preference.") }
    finally { button.disabled = false }
  } else send({ type: action })
}, true)
